/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {A11yModule} from '@angular/cdk/a11y';
import {OverlayModule} from '@angular/cdk/overlay';
import {MdCommonModule} from '@angular/material/core';
import {MdDrawer, MdDrawerContainer} from './drawer';
import {MdSidenav, MdSidenavContainer} from './sidenav';
export class MdSidenavModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, MdCommonModule, A11yModule, OverlayModule],
  exports: [MdDrawerContainer, MdDrawer, MdSidenavContainer, MdSidenav, MdCommonModule],
  declarations: [MdDrawerContainer, MdDrawer, MdSidenavContainer, MdSidenav],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSidenavModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSidenavModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSidenavModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
